module.exports = "/assets/dist/img/cart--white.svg?eba12b38e67c8448172a5c75042c4602";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/shared/svg/cart--white.svg
// module id = 786
// module chunks = 0 2